/**
 * https://jira.internetbrands.com/browse/PPE-248707
 *
 * make Google outstream player responsive for desktop and tablet
 *
 */
import { ua } from 'webmd-useragent';

function responsivePos5000Outstream() {
	let pos5000;
	if (ua && ua.type) {
		// for desktop and tablet
		if (ua.type === 'desktop' || ua.type === 'tablet') {
			pos5000 = document.querySelector('[id*="pos-5000"]');
		}
	}

	// check if we have pos-5000 on the page
	if (pos5000 && window.webmd && window.webmd.ads) {
		const elementId = pos5000.getAttribute('id');
		window.webmd.ads.googleDefer(() => {
			window.googletag.pubads().addEventListener('slotRenderEnded', (event) => {
				let adcontainer;
				let adContaineriframe;
				const soltElementId = event.slot.getSlotElementId();

				// to identify outstream -  640 x 480
				const isOutstreamVideo = (event.size && event.size[0] === 640 && event.size[1] === 480);

				// check if we have ad and it's outstream at pos 5000
				if (!event.isEmpty && isOutstreamVideo && elementId === soltElementId) {
					// ad container
					adcontainer = document.querySelector(`#${elementId} > div`);
					adcontainer.style.overflow = 'hidden';
					adcontainer.style.paddingTop = '78%';
					adcontainer.style.position = 'relative';
					adcontainer.style.width = '100%';

					// Edit first iFrame in side ad container
					adContaineriframe = document.querySelector(`#${elementId} > div > iframe`);
					adContaineriframe.style.bottom = '0';
					adContaineriframe.style.height = '100%';
					adContaineriframe.style.left = '0';
					adContaineriframe.style.position = 'absolute';
					adContaineriframe.style.right = '0';
					adContaineriframe.style.top = '0';
					adContaineriframe.style.width = '100%';
				}
			});
		});
	}
}
export default responsivePos5000Outstream;
